export const REQUEST_ERROR_MESSAGE_KEY = {
  DEFAULT: 'could_not_process_the_request',
  NETWORK: 'embedded_auth.network_connection_lost_try_again',
  SETTINGS_SAVE_FAILED: 'failed_to_save_settings',
  HABIT_INSTALL_FAILED: 'market.habit_install_fail',
  BRAIN_DUMP_FAILED:
    'to_do_procrastinate.sorry_unable_to_convert_brain_dumps_please_try_again',
  BRAIN_DUMP_TIMEOUT:
    'to_do_procrastinate.brain_dump_timeout_please_try_shorter_input'
} as const;

export const EMBEDDED_AUTH_ERROR_MESSAGE_KEY = {
  TIMEOUT: 'error_page.we_couldnt_refresh_your_sign_in_session_automatically',
  FAILED: 'error_page_message',
  NETWORK: REQUEST_ERROR_MESSAGE_KEY.NETWORK
} as const;

export const TRANSIENT_ERROR_PAYLOAD = { transient: true } as const;
